/**
 * free-gift.js  (Special Delivery)
 * -----------------------------------------------------------------------------
 * Free gift rules:
 *   - Any box on an ANNUAL Seal plan in the cart -> exactly ONE free gift, quantity 1.
 *   - No annual box in the cart                   -> free gift removed.
 *
 * Checked whenever the cart changes (drawer, cart page, add to cart) and on every
 * page load. Changes go through Venue's own cart store, so the cart drawer and
 * cart page update immediately.
 *
 * The gift's quantity selector and Remove link are hidden by CSS in
 * snippets/free-gift.liquid; this script also resets the quantity to 1 if it changes.
 * -----------------------------------------------------------------------------
 */

const FREE_GIFT_CONFIG = {
  // $0 free gift variant (new store)
  giftVariantId: 48461555105982,

  // Seal Subscriptions ANNUAL selling plan IDs (new store)
  annualSellingPlanIds: [
    15683453118, // Standard - annual
    15683518654, // Plus - annual
    15683584190, // Sunday Table - annual
  ],

  // Notification shown when the gift is added. Set to null to disable.
  addedMessage: "🎁 A free gift has been added to your order!",

  // Set to true to log decisions in the browser console
  debug: false,
};

(function () {
  "use strict";

  var CFG = FREE_GIFT_CONFIG;
  var GIFT = Number(CFG.giftVariantId);
  var ANNUAL = CFG.annualSellingPlanIds.map(Number);

  function log() {
    if (CFG.debug) console.log.apply(console, ["[FreeGift]"].concat([].slice.call(arguments)));
  }

  var busy = false;
  var again = false;
  var timer = null;

  function store() {
    return window.theme && theme.cart && theme.cart.store ? theme.cart.store : null;
  }

  function isGift(item) {
    return Number(item.variant_id) === GIFT;
  }

  function isAnnualBox(item) {
    if (isGift(item)) return false;
    var a = item.selling_plan_allocation;
    return !!(a && a.selling_plan && ANNUAL.indexOf(Number(a.selling_plan.id)) > -1);
  }

  // ---- Notification (same look as before) -----------------------------------
  function notify(message) {
    if (!message) return;
    var old = document.getElementById("free-gift-notification");
    if (old) old.remove();
    var el = document.createElement("div");
    el.id = "free-gift-notification";
    el.setAttribute("role", "status");
    el.setAttribute("aria-live", "polite");
    el.textContent = message;
    Object.assign(el.style, {
      position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
      background: "#1a1a1a", color: "#fff", padding: "12px 20px", borderRadius: "8px",
      fontSize: "14px", fontWeight: "500", zIndex: "9999", boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      transition: "opacity 0.4s ease", opacity: "1", whiteSpace: "nowrap", maxWidth: "90vw", textAlign: "center",
    });
    document.body.appendChild(el);
    setTimeout(function () {
      el.style.opacity = "0";
      setTimeout(function () { el.remove(); }, 400);
    }, 4000);
  }

  // ---- Core: bring the cart in line with the rules ------------------------------
  async function enforce() {
    var s = store();
    if (!s) return;
    if (busy) { again = true; return; }
    busy = true;
    try {
      var state = s.getState();
      // Let Venue finish its own in-flight line updates first
      if (state.lineItemsBeingUpdated && state.lineItemsBeingUpdated.length) {
        again = true;
        return;
      }
      var items = (state.products && state.products.items) || [];
      var hasAnnual = items.some(isAnnualBox);
      var gifts = items.filter(isGift);
      log("annual box in cart:", hasAnnual, "gift lines:", gifts.map(function (g) { return g.quantity; }));

      if (hasAnnual) {
        if (!gifts.length) {
          log("adding gift");
          await state.add([{ id: GIFT, quantity: 1 }]);
          notify(CFG.addedMessage);
        } else {
          // Extra gift lines -> remove; first line -> quantity exactly 1
          for (var i = gifts.length - 1; i >= 1; i--) {
            log("removing extra gift line", gifts[i].key);
            await s.getState().change(gifts[i].key, 0);
          }
          if (gifts[0].quantity !== 1) {
            log("resetting gift quantity to 1");
            await s.getState().change(gifts[0].key, 1);
          }
        }
      } else if (gifts.length) {
        for (var j = gifts.length - 1; j >= 0; j--) {
          log("removing gift (no annual box)", gifts[j].key);
          await s.getState().change(gifts[j].key, 0);
        }
      }
    } catch (err) {
      console.error("[FreeGift]", err);
    } finally {
      busy = false;
      if (again) { again = false; schedule(); }
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(enforce, 300);
  }

  // ---- Watch the cart -----------------------------------------------------------
  function signature(state) {
    var items = (state.products && state.products.items) || [];
    return items.map(function (i) {
      var sp = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan ? i.selling_plan_allocation.selling_plan.id : "";
      return i.variant_id + ":" + sp + ":" + i.quantity;
    }).join("|");
  }

  function init() {
    var tries = 40; // ~6 seconds
    (function wait() {
      var s = store();
      if (s && typeof s.getState === "function" && typeof s.getState().add === "function") {
        var last = signature(s.getState());
        s.subscribe(function (state) {
          var sig = signature(state);
          if (sig !== last) {
            last = sig;
            schedule();
          }
        });
        // Initial check: cart may already break the rules (e.g. changed in another tab)
        schedule();
        log("ready", CFG);
      } else if (--tries > 0) {
        setTimeout(wait, 150);
      } else {
        console.warn("[FreeGift] Venue cart store not found.");
      }
    })();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
